import axios from 'axios';

function isJsonString(str) {
   try {
      JSON.parse(str);
   } catch (e) {
      return false;
   }
   return true;
}

export const getTasks = async (page=1, pagesize=10, filters, search, sortContext, source) => {
   let contains = undefined;
   if(search) contains = search;
   const response = await axios.post(
      '/api/gpp/tasks/search',
      {
         contains,
         condition: {
            operator: "AND",
            conditions: [
               {
                  field: "isArchived",
                  value: "false",
                  operator: "="
               },
               {
                  field: "isDeleted",
                  operator: "=",
                  value: "false"
               },
               ...filters,
            ],
         },
         sortContext,
      },
      {
         params: {
            page,
            pagesize,
         },
         cancelToken: source.token,
      }
   );
   return {
      page,
      pagesize,
      tasks: response.data._embedded.tasks,
      pages: response.data._page.totalElements / pagesize,
      totalValues: response.data._page.totalElements,
   };
}

export const getTask = async (id, source) => {
   const response = await axios.get(
      `/api/gpp/tasks/${id}`,
      {
         cancelToken: source.token,
      }
   );
   return response.data;
}

export const getTaskAttachments = async (id, source) => {
   const response = await axios.get(
      `/api/gpp/tasks/${id}/attachments`,
      {
         cancelToken: source.token,
      }
   );
   const attachments = response.data._embedded.attachments
      .filter((attachment) => isJsonString(attachment.name))
      .map((attachment) => {
         const data = JSON.parse(attachment.name);
         return {
            id: attachment.id,
            data,
         };
      })
   return attachments;
}

export const addTaskAttachments = async (id, name, source) => {
   const response = await axios.post(
      `/api/gpp/tasks/${id}/attachments`,
      {
         name,
      },
      {
         cancelToken: source.token,
      }
   );
   return response.data;
}

export const createTask = async (data, source) => {
   const response = await axios.post(
      `/api/gpp/tasks`,
      data,
      {
         cancelToken: source.token,
      }
   );
   return response.data;
}

export const getTaskNotes = async (id, source) => {
   const response = await axios.get(
      `/api/gpp/tasks/${id}/notes`,
      {
         cancelToken: source.token,
      }
   );
   return response.data._embedded.notes;
}

export const addTaskNote = async (id, name, content, source) => {
   const response = await axios.post(
      `/api/gpp/tasks/${id}/notes`,
      {
         name,
         content,
      },
      {
         cancelToken: source.token,
      }
   );
   return response;
}

export const updateTask = async (task, data, source) => {
   const response = await axios.put(
      `/api/gpp/tasks/${task.id}`,
      {
         ...task,
         ...data,
      },
      {
         cancelToken: source.token,
      }
   );
   return response;
}

export const completeTask = async (params, source) => {
   const { note, motivations, taskId } = params;
   const response = await axios.patch(
      `/api/gpp/tasks/${taskId}/finish`,
      {
         note,
         motivations,
      },
      { cancelToken: source.token },
   );
   return response.data;
}

export const stopTask = async (params, source) => {
   const { note, motivations, taskId } = params;
   const response = await axios.patch(
      `/api/gpp/tasks/${taskId}/abort`,
      {
         note,
         motivations,
      },
      { cancelToken: source.token }
   );
   return response.data;
}

export const claimTask = async (id, source) => {
   const response = await axios.patch(`/api/gpp/tasks/${id}/claim`, {}, { cancelToken: source.token });
   return response.data;
}

export const releaseTask = async (id, source) => {
   const response = await axios.patch(`/api/gpp/tasks/${id}/release`, {}, { cancelToken: source.token });
   return response.data;
}

export const startTask = async (id, source) => {
   const response = await axios.patch(`/api/gpp/tasks/${id}/start`, {}, { cancelToken: source.token });
   return response.data;
}

export const pauseTask = async (id, source) => {
   const response = await axios.patch(`/api/gpp/tasks/${id}/pause`, {}, { cancelToken: source.token });
   return response.data;
}

export const startTaskBulk = async (id, mAccounts, source) => {
   const response = await axios.patch(`/api/gpp/tasks/${id}/start-bulk`, 
      { mAccounts }, 
      { cancelToken: source.token }
   );
   return response.data;
}

export const pauseTaskBulk = async (id, mAccounts, source) => {
   const response = await axios.patch(`/api/gpp/tasks/${id}/pause-bulk`, 
      { mAccounts }, 
      { cancelToken: source.token }
   );
   return response.data;
}

export const releaseTaskBulk = async (id, mAccounts, source) => {
   const response = await axios.patch(`/api/gpp/tasks/${id}/release-bulk`, 
      { mAccounts }, 
      { cancelToken: source.token }
   );
   return response.data;
}

export const assignTaskBulk = async (id, mAccounts, source) => {
   const response = await axios.put(`/api/gpp/tasks/${id}/assign`, 
      { mAccounts }, 
      { cancelToken: source.token }
   );
   return response.data;
}